import { Offcanvas, Form } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useRef, useState } from "react";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";
import { OrganizationInterface } from "./Organization";
import HelperService from "../../utility/HelperService";
import { useForm, Controller } from "react-hook-form";
import Select from "react-dropdown-select";
import { Upload } from "lucide-react";

interface PropData {
    show: boolean
    handleClose: () => void
    data: OrganizationInterface | null
}
interface Option {
    label: string;
    value: string;
}


// const categoryOptions: Option[] = [
//     { label: "Information Technology", value: "IT" },
//     { label: "Manufacturing", value: "manufacturing" },
//     { label: "Finance", value: "finance" },
// ];

const AddOrganization = (props: PropData) => {
    const { register, handleSubmit, formState: { errors }, reset, setValue, watch, control } = useForm<OrganizationInterface>({
        mode: "onChange",
        defaultValues: {
            category: "",
            country: "",
            state: "",
            city: ""
        }
    });
    const [isLoading, setLoading] = useState(false);
    const [bladeTitle, setBladeTitle] = useState("");
    const [selectedUser, setSelectedUser] = useState<OrganizationInterface | null>(null);
    const [countryOptions, setCountryOptions] = useState<Option[]>([]);
    const [stateOptions, setStateOptions] = useState<Option[]>([]);
    const [cityOptions, setCityOptions] = useState<Option[]>([]);
    const [category, setCategory] = useState<Option[]>([]);
    const [country, setCountry] = useState<Option[]>([]);
    const [state, setState] = useState<Option[]>([]);
    const [city, setCity] = useState<Option[]>([]);
    const [logoFile, setLogoFile] = useState<File | null>(null);
    const [previewUrl, setPreviewUrl] = useState<string | null>(null);
    const [categoryOptions, setCategoryOptions] = useState<Option[]>([]);

    const fileInputRef = useRef<HTMLInputElement | null>(null);


    console.log("logoFile", logoFile);

    useEffect(() => {
        getCategories();
        loadCountries();
        if (props.data) {
            setBladeTitle('Edit Organization')

            const categoryObj: any = props.data.category;
            const countryObj: any = props.data.country;
            const stateObj: any = props.data.state;
            const cityObj: any = props.data.city;

            reset({
                ...props.data,
                category: categoryObj?._id,
                country: countryObj?._id,
                state: stateObj?._id,
                city: cityObj?._id
            });

            setPreviewUrl(props.data.logo || null);

            // load states for edit
            if (countryObj?._id) {
                loadStates(countryObj._id);
            }

            // load cities for edit
            if (stateObj?._id) {
                loadCities(stateObj._id);
            }
        } else {
            reset({})
            setBladeTitle('Add Organization')
            setLogoFile(null);
            setPreviewUrl(null);
            setCategory([]);
            setCountry([]);
            setState([]);
            setCity([]);

        }
    }, [props.show])
    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            setLogoFile(file);
            setPreviewUrl(URL.createObjectURL(file));
        }
    };
    const handleClose = props.handleClose;
    const show = props.show;
    const data = props.data;

    const onCloseModal = (e?: any) => {
        reset({})
        props.handleClose()
    };

    const getCategories = async () => {
        try {
            const res: any = await WebService.getAPI({ action: "categories/get-list/organization" });

            setCategoryOptions(
                res.data.map((c: any) => ({
                    label: c.name,
                    value: c._id,
                }))
            );
        } catch (err) {
            toast.error("Failed to load countries");
        }
    };
    const loadCountries = async () => {
        try {
            const res: any = await WebService.getAPI({ action: "location/countries" });
            setCountryOptions(res.data.map((c: any) => ({ label: c.name, value: c._id, })));
        } catch (err) {
            toast.error("Failed to load countries");
        }
    };

    const loadStates = async (countryId: string) => {
        try {
            const res: any = await WebService.getAPI({
                action: `location/states?countryId=${countryId}`,
            });

            setStateOptions(
                res.data.map((s: any) => ({
                    label: s.name,
                    value: s._id
                }))
            );

        } catch {
            toast.error("Failed to load states");
        }
    };

    const loadCities = async (stateId: string) => {
        try {

            const res: any = await WebService.getAPI({
                action: `location/cities?stateId=${stateId}`,
            });

            setCityOptions(
                res.data.map((c: any) => ({
                    label: c.name,
                    value: c._id
                }))
            );

        } catch {
            toast.error("Failed to load cities");
        }
    };
    const handleCountryChange = async (selected: Option[]) => {

        setStateOptions([]);
        setCityOptions([]);

        if (!selected.length) return;

        loadStates(selected[0].value);
    };

    const handleStateChange = async (selected: Option[]) => {

        setCityOptions([]);

        if (!selected.length) return;

        loadCities(selected[0].value);
    };


    // const onSubmit = (requestBody: OrganizationInterface) => {
    //     setLoading(true)
    //     WebService[props.data?._id ? 'putAPI' : 'postAPI']({
    //         action: props.data?._id ? `organizations/update-organization` : `admin-user/user/create`,
    //         body: requestBody,
    //         id: 'saveUserButton'
    //     })
    //         .then((res: any) => {
    //             toast.success(props.data?._id ? 'Organization Updated Successfully.' : 'Organization Created Successfully.')
    //             setLoading(false)
    //             handleClose()
    //         })
    //         .catch((error) => {
    //             toast.error(error?.response?.data?.message || 'Something went wrong. Please try again later.')
    //             setLoading(false)
    //         })
    // }

    const removeLogo = () => {
        setLogoFile(null);
        setPreviewUrl(null);

        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };
    const onSubmit = async (formData: OrganizationInterface) => {
        setLoading(true);
        const id = data ? data._id : "";
        const formDataToSend = new FormData();
        formDataToSend.append("name", formData.name);
        formDataToSend.append("website", formData.website ?? "");
        formDataToSend.append("email", formData.email ?? "");
        formDataToSend.append("phone", formData.phone ?? "");
        formDataToSend.append("gstNumber", formData.gstNumber ?? "");
        formDataToSend.append("category", String(formData.category ?? ""));
        formDataToSend.append("country", String(formData.country ?? ""));
        formDataToSend.append("state", String(formData.state ?? ""));
        formDataToSend.append("city", String(formData.city ?? ""));
        formDataToSend.append("address", formData.address ?? "");
        formDataToSend.append("pinCode", formData.pinCode ?? "");

        // Only send logo if a new file is selected
        if (logoFile) {
            console.log(logoFile)
            formDataToSend.append("logo", logoFile);
        }

        if (!previewUrl) {
            formDataToSend.append("removeLogo", "true");
        }

        console.log(formDataToSend, ">>>")

        try {
            let res: any;
            if (data && data._id) {
                res = await WebService.fileUploadPutAPI({
                    action: `organizations/edit/${id}`,
                    body: formDataToSend,
                    isFormData: true,
                });
            } else {
                res = await WebService.fileUploadAPI({
                    action: `organizations/create-organization`,
                    body: formDataToSend,
                    isFormData: true,
                });
            }
            toast.success(res.message || (data && data._id ? "Organisation updated successfully" : "Organisation created successfully"));
            setLoading(false);
            handleClose();
        } catch (error: any) {
            toast.error(error?.response?.data?.message || "Failed to save organisation");
            setLoading(false);
        }
    };
    return (
        <>
            <Offcanvas
                show={show}
                onHide={() => { reset(); onCloseModal(); }}
                placement="end"
                className="offcanvas-large"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>{bladeTitle}</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="mt-1">
                            <Form.Label className="label">
                                Upload Logo {/* <span className="text-danger">*</span> */}
                            </Form.Label>
                            <p
                                className="text-primary mt-1"
                                style={{ fontSize: "13px" }}
                            >
                                Note: Please upload an image of size:{" "}
                                <strong>42 × 37 px</strong> in{" "}
                                <strong>.png, .jpeg, .jpg or .svg</strong> format.
                            </p>
                            <div className="upload-image position-relative" onClick={() => fileInputRef.current?.click()} style={{ cursor: "pointer" }}>
                                {previewUrl ? (
                                    <div className="position-relative">
                                        <img src={previewUrl} alt="Logo Preview" className="w-100 max-h-32 object-contain mx-auto" />
                                        <span
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                removeLogo();
                                            }}
                                            style={{
                                                position: "absolute",
                                                top: "-8px",
                                                right: "-8px",
                                                background: "red",
                                                color: "#fff",
                                                width: "22px",
                                                height: "22px",
                                                borderRadius: "50%",
                                                fontSize: "14px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                cursor: "pointer",
                                                zIndex: 10
                                            }}
                                        >
                                            ✕
                                        </span>
                                    </div>
                                ) : (
                                    <div>
                                        <Upload size={20} className="text-primary mb-2" />
                                        <span className="text-primary text-sm">
                                            Click to Upload Logo
                                        </span >
                                        {errors.logo && <p className="text-red-500 text-sm mt-1">{errors.logo.message}</p>}
                                        {logoFile && (
                                            <p className="text-sm text-gray-500 mt-1">
                                                Selected: {logoFile.name}
                                            </p>
                                        )}
                                    </div>
                                )}
                                <input
                                    type="file"
                                    accept="image/*"
                                    ref={fileInputRef}
                                    onChange={handleFileChange}
                                    style={{ display: "none" }}
                                />
                            </div>

                            <Form.Group className="mb-2" controlId="eventName">
                                <Form.Label className="label">
                                    Organization Name <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter name"
                                    {...register("name", { required: "Please enter name" })}
                                />
                                {errors.name && (
                                    <div className="error-message">{errors.name.message}</div>
                                )}
                            </Form.Group>

                            <div className="form-group">
                                <Form.Label className="label">
                                    Office Phone {/* <span className="text-danger">*</span> */}
                                </Form.Label>
                                <input
                                    className="form-control"
                                    type="text"
                                    placeholder="Enter Office Phone"
                                    maxLength={10}
                                    {...register(`phone`, {
                                        required: false,
                                        minLength: {
                                            value: 10,
                                            message: 'Office phone  must be 10 digits'
                                        },
                                        pattern: {
                                            value: /^[0-9]{10}$/,
                                            message: "Please enter valid office phone",
                                        },
                                    })}
                                    onKeyPress={(e: any) => HelperService.allowOnlyNumericValue(e)}
                                />
                                {errors.phone && (
                                    <div className="error-message">{errors.phone.message}</div>
                                )}
                            </div>
                            <div className="form-group">
                                <Form.Label className="label">
                                    Office Email
                                </Form.Label>
                                <input
                                    className="form-control"
                                    placeholder="Enter Email"
                                    type="text"
                                    {...register(`email`, { required: false, pattern: /^\S+@\S+$/i })}
                                />
                                {errors.email && <div className="error-message">{'Please enter valid email'}</div>}
                            </div>

                            <div className="form-group">
                                <Form.Label className="label">
                                    Website <span className="text-danger">*</span>
                                </Form.Label>
                                <input
                                    className="form-control"
                                    placeholder="Enter Website"
                                    type="text"
                                    {...register(`website`, { required: true, pattern: /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/i })}
                                />
                                {errors.website && <div className="error-message">{'Please enter valid website'}</div>}
                            </div>
                            <div className="form-group">
                                <Form.Label className="label">
                                    GST Number
                                </Form.Label>
                                <input
                                    className="form-control"
                                    placeholder="Enter GST Number"
                                    type="text"
                                    {...register(`gstNumber`, { required: false, pattern: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/i })}
                                />
                                {errors.gstNumber && <div className="error-message">{'Please enter valid GST Number'}</div>}
                            </div>
                            <div className="form-group">
                                <Form.Label className="label">
                                    Category <span className="text-danger">*</span>
                                </Form.Label>

                                <Controller
                                    name="category"
                                    control={control}
                                    rules={{ required: "Please select Category" }}
                                    render={({ field }) => (
                                        <Select
                                            options={categoryOptions}
                                            values={categoryOptions.filter((c) => c.value === field.value)}
                                            onChange={(val) => {
                                                const value = val[0]?.value;
                                                field.onChange(value);
                                                // setValue("category", value, { shouldValidate: true, shouldDirty: true });
                                            }}
                                            labelField="label"
                                            valueField="value"
                                            placeholder="Select"
                                            className="form-control"
                                        />
                                    )}
                                />

                                {errors.category && (
                                    <div className="error-message">{errors.category.message}</div>
                                )}
                            </div>
                            <div className="form-group">
                                <Form.Label className="label">
                                    Country <span className="text-danger">*</span>
                                </Form.Label>
                                <Controller
                                    name="country"
                                    control={control}
                                    rules={{ required: "Please select Country" }}
                                    render={({ field }) => (
                                        <Select
                                            options={countryOptions}
                                            values={countryOptions.filter((c) => c.value === field.value)}
                                            onChange={(val) => {
                                                const value = val[0]?.value;
                                                handleCountryChange(val);
                                                field.onChange(value);
                                                // setValue("country", value, { shouldValidate: true, shouldDirty: true });
                                            }}
                                            labelField="label"
                                            valueField="value"
                                            placeholder="Select"
                                            className="form-control"
                                        />
                                    )}
                                />

                                {errors.country && (
                                    <div className="error-message">{errors.country.message}</div>
                                )}
                            </div>

                            <div className="form-group">
                                <Form.Label className="label">
                                    State <span className="text-danger">*</span>
                                </Form.Label>
                                <Controller
                                    name="state"
                                    control={control}
                                    rules={{ required: "Please select State" }}
                                    render={({ field }) => (
                                        <Select
                                            options={stateOptions}
                                            values={stateOptions.filter((s) => s.value === field.value)}
                                            onChange={(val) => {
                                                const value = val[0]?.value;
                                                handleStateChange(val);
                                                field.onChange(value);
                                                // setValue("state", value, { shouldValidate: true, shouldDirty: true });
                                            }}
                                            labelField="label"
                                            valueField="value"
                                            placeholder="Select"
                                            className="form-control"
                                        />
                                    )}
                                />

                                {errors.state && (
                                    <div className="error-message">{errors.state.message}</div>
                                )}
                            </div>

                            <div className="form-group">
                                <Form.Label className="label">
                                    City <span className="text-danger">*</span>
                                </Form.Label>
                                <Controller
                                    name="city"
                                    control={control}
                                    rules={{ required: "Please select City" }}
                                    render={({ field }) => (
                                        <Select
                                            options={cityOptions}
                                            values={cityOptions.filter((c) => c.value === field.value)}
                                            onChange={(val) => {
                                                const value = val[0]?.value;
                                                field.onChange(value);
                                                // setValue("city", value, { shouldValidate: true, shouldDirty: true });
                                            }}
                                            labelField="label"
                                            valueField="value"
                                            placeholder="Select"
                                            className="form-control"
                                        />
                                    )}
                                />

                                {errors.city && (
                                    <div className="error-message">{errors.city.message}</div>
                                )}
                            </div>

                            <div className="form-group">
                                <Form.Label className="label">
                                    Pin Code <span className="text-danger">*</span>
                                </Form.Label>
                                <input
                                    className="form-control"
                                    placeholder="Enter Pin Code"
                                    type="text"
                                    {...register(`pinCode`, { required: true, pattern: /^[0-9]{6}$/ })}
                                    onKeyDown={(e) => {
                                        // ❌ Block non-numeric keys
                                        if (
                                            !/[0-9]/.test(e.key) &&
                                            ![
                                                "Backspace",
                                                "Delete",
                                                "ArrowLeft",
                                                "ArrowRight",
                                                "Tab",
                                            ].includes(e.key)
                                        ) {
                                            e.preventDefault();
                                        }
                                    }}
                                />
                                {errors.pinCode && <div className="error-message">{'Please enter valid Pin Code'}</div>}
                            </div>

                            <div className="form-group">
                                <Form.Label className="label">
                                    Address <span className="text-danger">*</span>
                                </Form.Label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter Address"
                                    {...register(`address`, { required: true })}
                                />
                                {errors.address && <div className="error-message">{'Please enter  Address'}</div>}
                            </div>

                            <div className="d-flex justify-content-end p-3">
                                <CustomButton
                                    isLoading={isLoading}
                                    label="Save"
                                    className="w-100"
                                    type="submit"
                                    id="saveUserButton"
                                />
                            </div>
                        </div>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>

    );
};

export default AddOrganization;
